import { ContentSidebarLayout } from 'components/Layouts/ContentSidebarLayout';
import { TradeEventFilterTray } from 'components/TradeEventFilterTray';
import { TradeEventTable } from 'components/TradeEventTable/TradeEventTable';
import { observer } from 'mobx-react-lite';

export const TradeEvents = observer(() => (
  <ContentSidebarLayout title="Trade events" sidebarContent={<TradeEventFilterTray />}>
    <TradeEventTable />
  </ContentSidebarLayout>
));
